/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React, { useContext, useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MonthInvoiceDetails from './MonthInvoiceDetails';
import RecentInvoiceDetails from './RecentInvoiceDetails';
import ContractConsumptions from './ContractConsumptions';
import TonnageConsumptions from './TonnageConsumptions';
import { AppContext } from '../../context/AppContext';
import { useWindowSize } from '../../hooks/custom-hooks/useSidebarHook';
import TodayDeliveredSchedule from './TodayDeliveredSchedule';

function MyWidgets(props) {
  const [expanded, setExpanded] = useState(true);
  const { widgetSettings } = useContext(AppContext);
  const [width] = useWindowSize();

  useEffect(() => {
    if (width < 1180) setExpanded(false);
    else setExpanded(true);
  }, [width]);

  const renderWidget = (WidgetName, customerId, projectId, widgetIndex) => {
    switch (WidgetName) {
      case 'MonthInvoiceDetails':
        return (
          <MonthInvoiceDetails
            isSelectedWidget
            customerId={customerId}
            projectId={projectId}
            widgetIndex={widgetIndex}
            authToken={props?.authToken}
          />
        );
      case 'RecentInvoiceDetails':
        return (
          <RecentInvoiceDetails
            isSelectedWidget
            customerId={customerId}
            projectId={projectId}
            widgetIndex={widgetIndex}
            authToken={props?.authToken}
          />
        );
      case 'ContractConsumptions':
        return (
          <ContractConsumptions
            isSelectedWidget
            customerId={customerId}
            projectId={projectId}
            widgetIndex={widgetIndex}
            authToken={props?.authToken}
          />
        );
      case 'TodayDeliveredSchedule':
        return (
          <TodayDeliveredSchedule
            isSelectedWidget
            customerId={customerId}
            projectId={projectId}
            widgetIndex={widgetIndex}
            authToken={props?.authToken}
          />
        );
      case 'TonnageConsumptions':
        return (
          <TonnageConsumptions
            isSelectedWidget
            customerId={customerId}
            projectId={projectId}
            widgetIndex={widgetIndex}
            authToken={props?.authToken}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className=''>
      <Accordion
        className='!rounded-xl bg-white'
        onClick={() => setExpanded(!expanded)}
        expanded={width > 1180 ? true : expanded}
      >
        <AccordionSummary
          className='my-widget-title break:pointer-events-none break:hidden'
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1a-content'
          id='panel1a-header'
        >
          <h2 className='text-base font-semibold'>My Widgets</h2>
        </AccordionSummary>
        <AccordionDetails
          onClick={(e) => e.stopPropagation()}
          className='overflow-auto break:mt-6 break:h-[calc(100vh-140px)] breakMax:max-h-[620px]'
        >
          {widgetSettings?.selected?.map((s, i) => (
            <div key={`${s?.name}${i}`} className={`${i > 0 ? 'mt-4' : ''}`}>
              <div>{renderWidget(s?.name, s?.customerId, s?.projectId, i)}</div>
            </div>
          ))}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default MyWidgets;
